
import { store } from '@/vuex/store'
import permissioner from "@/services/permissioner.js"


const refreshPeriodicallyToken = async ()=>{
    setInterval(async()=>{
        await permissioner.getLoggedInUser();
        console.log("Getting new token right now",store.state )
    }, (5*60000))
}

export {refreshPeriodicallyToken}